import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const TABLE_COLUMNS = [
  "Transaction Amount",
  "Avg. Assets",
  "Receivable Trail Amount",
  "Received Trail amount",
  "Gap (Receivable - Received)",
];

export default function BrokerageReconciliation() {
  const [processMonth, setProcessMonth] = useState("01-2026");
  const [groupBy, setGroupBy] = useState("Fund");
  const [funds, setFunds] = useState("All");
  const [schemes, setSchemes] = useState("All");
  const [arn, setArn] = useState("All");
  const [checks, setChecks] = useState("All"); // All | Mismatch Only | Higher Rate Receivable | Lower Rate Receivable
  const [viewType, setViewType] = useState("onScreen");
  const [sortBy, setSortBy] = useState("Fund");
  const [sortDir, setSortDir] = useState("asc");

  const rows = []; // No data - empty state

  const handleApply = (e) => {
    e.preventDefault();
    console.log({ processMonth, groupBy, funds, schemes, arn, checks, viewType });
  };

  const handleRequestReconciliation = (e) => {
    e.preventDefault();
    console.log("Request Reconciliation", processMonth);
  };

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{ color: sortBy === columnKey ? teal : "#64748b", fontSize: "11px" }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
    </button>
  );

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Brokerage Reconciliation</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/brokerage/income-detail">Brokerage</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Brokerage Reconciliation
                </li>
              </ol>
            </nav>
          </div>

          {/* Filter card */}
          <div style={cardStyle}>
            <form onSubmit={handleApply}>
              {/* Process Month + Request Reconciliation link */}
              <div className="mb-4 d-flex flex-wrap align-items-end gap-3">
                <div style={{ minWidth: 140 }}>
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Process Month:</label>
                  <input
                    type="text"
                    placeholder="MM-YYYY"
                    value={processMonth}
                    onChange={(e) => setProcessMonth(e.target.value)}
                    style={{ ...inputStyle, maxWidth: 120 }}
                    maxLength={7}
                  />
                </div>
                <button
                  type="button"
                  onClick={handleRequestReconciliation}
                  className="border-0 bg-transparent p-0"
                  style={{ color: teal, fontWeight: 600, fontSize: "14px", cursor: "pointer", textDecoration: "underline" }}
                >
                  Request Reconciliation
                </button>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Group By:</label>
                <div className="d-flex flex-wrap gap-4">
                  {["Fund", "Scheme", "Transaction"].map((opt) => (
                    <label key={opt} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input type="radio" name="groupBy" checked={groupBy === opt} onChange={() => setGroupBy(opt)} style={{ accentColor: teal }} />
                      {opt}
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Filter:</label>
                <div className="row g-3">
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary mb-1 d-block">Funds</label>
                    <select value={funds} onChange={(e) => setFunds(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary mb-1 d-block">Schemes</label>
                    <select value={schemes} onChange={(e) => setSchemes(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary mb-1 d-block">ARN</label>
                    <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Checks:</label>
                <div className="d-flex flex-wrap gap-4">
                  {["All", "Mismatch Only", "Higher Rate Receivable", "Lower Rate Receivable"].map((opt) => (
                    <label key={opt} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input type="radio" name="checks" checked={checks === opt} onChange={() => setChecks(opt)} style={{ accentColor: teal }} />
                      {opt}
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">View Type:</label>
                <div className="d-flex gap-4">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input type="radio" name="viewType" checked={viewType === "onScreen"} onChange={() => setViewType("onScreen")} style={{ accentColor: teal }} />
                    On Screen
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input type="radio" name="viewType" checked={viewType === "xls"} onChange={() => setViewType("xls")} style={{ accentColor: teal }} />
                    XLS
                  </label>
                </div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>

          {/* Results table */}
          <div style={{ ...cardStyle, padding: 0, overflowX: "auto" }}>
            <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc" }}>
                  <th
                    className="text-nowrap"
                    style={{
                      padding: "10px 12px",
                      fontWeight: 600,
                      color: "#334155",
                      borderBottom: sortBy === groupBy ? `2px solid ${teal}` : undefined,
                      backgroundColor: sortBy === groupBy ? "rgba(6, 209, 198, 0.08)" : undefined,
                    }}
                  >
                    {groupBy}
                    <SortIcon columnKey={groupBy} />
                  </th>
                  {TABLE_COLUMNS.map((label) => (
                    <th
                      key={label}
                      className="text-nowrap"
                      style={{
                        padding: "10px 12px",
                        fontWeight: 600,
                        color: "#334155",
                        borderBottom: sortBy === label ? `2px solid ${teal}` : undefined,
                      }}
                    >
                      {label}
                      <SortIcon columnKey={label} />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={TABLE_COLUMNS.length + 1} style={{ padding: "48px 24px", verticalAlign: "middle" }}>
                      <div className="text-center">
                        <div className="mb-2">
                          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "42px", color: "#f59e0b" }} aria-hidden />
                        </div>
                        <div style={{ fontWeight: 600, color: "#334155" }}>No data available.</div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  rows.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "10px 12px" }}>{row.groupLabel}</td>
                      <td style={{ padding: "10px 12px" }}>{row.transactionAmount}</td>
                      <td style={{ padding: "10px 12px" }}>{row.avgAssets}</td>
                      <td style={{ padding: "10px 12px" }}>{row.receivableTrailAmount}</td>
                      <td style={{ padding: "10px 12px" }}>{row.receivedTrailAmount}</td>
                      <td style={{ padding: "10px 12px" }}>{row.gap}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
